import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["carrier", "additionalService"]

  filter() {
    const filters = {
      carrier: this.carrierTarget.value,
      additional_service_id: this.additionalServiceTarget.value
    }
    this.stimulate("AdditionalServiceFactorReflex#filter", filters);
  }
}
